import { decodeQuery } from '@zedoc/url';

const query = decodeQuery(window.location.search);

const isNavigationDisabled = query.no_nav === '1';

export default isNavigationDisabled;
